import { createTheme } from "@mui/material/styles";
import { DARK_TOKENS, LIGHT_TOKENS } from "./tokens";

const fontFamily = [
  "Montserrat",
  "Arial",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  "sans-serif",
].join(", ");

export const customTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#109bc5",
    },
    secondary: {
      main: "#2f82f1",
    },
    background: {
      default: "#fff",
    },
  },
  typography: { fontFamily },
  // The shop's named roles — see ./tokens.ts. Components read these instead
  // of pasting a hex, which is what stops a fifth blue appearing.
  tokens: LIGHT_TOKENS,
});

export const customThemeDark = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#109bc5",
    },
    secondary: {
      main: "#2f82f1",
    },
  },
  typography: { fontFamily },
  tokens: DARK_TOKENS,
});
